"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _numberField = _interopRequireDefault(require("./number-field"));

var MoneyField =
/*#__PURE__*/
function (_NumberField) {
  (0, _inherits2.default)(MoneyField, _NumberField);

  function MoneyField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MoneyField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MoneyField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'MoneyField');
    return _this;
  }

  (0, _createClass2.default)(MoneyField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(MoneyField.prototype), "_create", this).call(this, props);
      var prefix = props.prefix,
          thousandsSeparatorSymbol = props.thousandsSeparatorSymbol,
          allowDecimal = props.allowDecimal,
          decimalLimit = props.decimalLimit; // Note: we cannot use setDefaults as we need to utilize inherited logic in set()

      this.set({
        prefix: prefix !== undefined ? prefix : '$',
        thousandsSeparatorSymbol: thousandsSeparatorSymbol !== undefined ? thousandsSeparatorSymbol : ',',
        allowDecimal: allowDecimal !== undefined ? allowDecimal : true,
        decimalLimit: decimalLimit !== undefined ? decimalLimit : 2
      });
    }
  }]);
  return MoneyField;
}(_numberField.default);

exports.default = MoneyField;